<template>
  <div class="sub-card">
    <b-collapse v-model="collapse" animation="slide">
      <template #trigger="props">
        <div class="card-header">
          <p class="card-header-title">
            {{ title }}
          </p>

          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-up' : 'menu-down'"> </b-icon>
          </a>
        </div>
      </template>
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      collapse: false,
    };
  },
};
</script>
